import type { ReactNode } from "react"
import "./app-shell.css"

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="app-shell">
      <div className="app-shell-bg" aria-hidden="true">
        <div className="app-shell-glow app-shell-glow--left" />
        <div className="app-shell-glow app-shell-glow--right" />
        <div className="app-shell-grid" />
      </div>
      <div className="app-shell-content">{children}</div>
    </div>
  )
}
